import React from 'react';
import Swal from 'sweetalert2';
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faSave,
    faTimes,
    faSearch,
    faCheckCircle,
    faFileInvoice,
    faNotesMedical,
    faChevronLeft,
    faChevronRight,
    faEye,
    faTimes as faClose,
    faExclamationTriangle,
    faMoneyBillWave,
    faChevronDown
} from '@fortawesome/free-solid-svg-icons';
import { DefaultLayout } from '../../layout/theme-customizer';
import Ordenes from './Index';

const LS_KEY = 'liquidarOrdenesSeleccionadas_v2';

// ─────────────────────────────────────────────────────────────────────────────
// Select con búsqueda interna (reutilizable)
// ─────────────────────────────────────────────────────────────────────────────
class SearchableSelect extends React.Component {
    constructor(props) {
        super(props);
        this.state = { open: false, busqueda: '' };
        this.ref = React.createRef();
    }

    componentDidMount() { document.addEventListener('mousedown', this.handleOutsideClick); }
    componentWillUnmount() { document.removeEventListener('mousedown', this.handleOutsideClick); }

    handleOutsideClick = (e) => {
        if (this.ref.current && !this.ref.current.contains(e.target))
            this.setState({ open: false });
    };

    toggle = () => this.setState(s => ({ open: !s.open, busqueda: '' }));

    seleccionar = (value) => {
        this.props.onChange(value);
        this.setState({ open: false, busqueda: '' });
    };

    render() {
        const { opciones = [], value, placeholder, labelKey, valueKey, required, disabled } = this.props;
        const { open, busqueda } = this.state;

        const filtradas = opciones.filter(o =>
            String(o[labelKey] || '').toLowerCase().includes(busqueda.toLowerCase())
        );
        const seleccionado = opciones.find(o => String(o[valueKey]) === String(value));

        return (
            <div ref={this.ref} style={{ position: 'relative' }}>
                {/* Disparador */}
                <div
                    onClick={() => !disabled && this.toggle()}
                    className={`form-control form-control-sm d-flex justify-content-between align-items-center${required && !value ? ' is-invalid' : ''}`}
                    style={{ cursor: disabled ? 'not-allowed' : 'pointer', background: disabled ? '#e9ecef' : '#fff', minHeight: '31px', userSelect: 'none' }}
                >
                    <span style={{ fontSize: '13px', color: seleccionado ? '#212529' : '#6c757d', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', maxWidth: '90%' }}>
                        {seleccionado ? seleccionado[labelKey] : (placeholder || '-- Seleccione --')}
                    </span>
                    <FontAwesomeIcon icon={faChevronDown} style={{ fontSize: '10px', color: '#6c757d', flexShrink: 0 }} />
                </div>
                {required && !value && <div className="invalid-feedback" style={{ display: 'block' }}>Campo obligatorio</div>}

                {/* Dropdown */}
                {open && (
                    <div style={{ position: 'absolute', zIndex: 9999, width: '100%', background: '#ffffff', border: '1px solid #ced4da', borderRadius: '4px', boxShadow: '0 4px 12px rgba(0,0,0,0.2)', top: '100%', left: 0, color: '#212529' }}>
                        {/* Buscador */}
                        <div style={{ padding: '6px 6px 4px', background: '#ffffff' }}>
                            <input
                                autoFocus
                                type="text"
                                placeholder="Buscar..."
                                value={busqueda}
                                onChange={e => this.setState({ busqueda: e.target.value })}
                                onClick={e => e.stopPropagation()}
                                style={{
                                    width: '100%', padding: '4px 8px', fontSize: '13px',
                                    border: '1px solid #ced4da', borderRadius: '4px',
                                    outline: 'none', color: '#212529', background: '#fff'
                                }}
                            />
                        </div>
                        {/* Opciones */}
                        <ul style={{ listStyle: 'none', margin: 0, padding: 0, maxHeight: '210px', overflowY: 'auto', background: '#ffffff' }}>
                            <li
                                style={{ padding: '6px 10px', cursor: 'pointer', fontSize: '13px', color: '#6c757d', borderBottom: '1px solid #f0f0f0', background: '#ffffff' }}
                                onClick={() => this.seleccionar('')}
                                onMouseEnter={e => e.currentTarget.style.background = '#f8f9fa'}
                                onMouseLeave={e => e.currentTarget.style.background = '#ffffff'}
                            >
                                {placeholder || '-- Seleccione --'}
                            </li>
                            {filtradas.length === 0 ? (
                                <li style={{ padding: '8px 10px', color: '#999', fontSize: '13px', background: '#fff' }}>Sin resultados</li>
                            ) : filtradas.map(o => {
                                const activo = String(o[valueKey]) === String(value);
                                return (
                                    <li key={o[valueKey]}
                                        style={{
                                            padding: '6px 10px', cursor: 'pointer', fontSize: '13px',
                                            color: activo ? '#0c4a8a' : '#212529',
                                            background: activo ? '#e8f4fd' : '#ffffff',
                                            fontWeight: activo ? '600' : 'normal'
                                        }}
                                        onClick={() => this.seleccionar(o[valueKey])}
                                        onMouseEnter={e => { e.currentTarget.style.background = '#f0f7ff'; e.currentTarget.style.color = '#0c4a8a'; }}
                                        onMouseLeave={e => { e.currentTarget.style.background = activo ? '#e8f4fd' : '#ffffff'; e.currentTarget.style.color = activo ? '#0c4a8a' : '#212529'; }}
                                    >
                                        {o[labelKey]}
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                )}
            </div>
        );
    }
}

// ─────────────────────────────────────────────────────────────────────────────
// Componente principal
// ─────────────────────────────────────────────────────────────────────────────
class Liquidar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            // Filtros
            busqueda: '',
            paciente: '',
            atencion: '',
            fecha_desde: '',
            fecha_hasta: '',
            solo_revisados: false,
            asignado: '',           // obligatorio

            // Datos paginados
            ordenes: [],
            total: 0,
            pagina_actual: 1,
            por_pagina: 50,
            ultima_pagina: 1,
            cargando: false,

            // Selección masiva
            ordenesSeleccionadas: this.cargarSeleccionadasStorage(),
            seleccionarTodos: false,
            epsSeleccionada: null,

            // Modal ver orden
            showModalOrden: false,
            ordenSeleccionada: null,

            // Modal liquidación
            showModalLiquidacion: false,
            ordenLiquidar: null,
            costoLiquidar: 0,
            cargandoCosto: false,
            liq_estado: 1,
            liq_profesional: '',
            liq_cantidad: '',
            liq_valor_und: '',
            liq_total: '',
            liq_tipo: '',
            liq_fecha_inicio: '',
            liq_fecha_final: '',
            liq_atencion: '',
            guardandoLiq: false,

            // Modal facturación
            showModalFacturacion: false,
            epsFacturacion: '',
            regimenFacturacion: '',
            facturando: false,

            // Catálogos
            usuarios: [],
            pacientes: [],
            atenciones: [],
            empresas: [],
            regimenes: [],

            warningMessage: ''
        };
    }

    // ── Alertas ───────────────────────────────────────────────────────────────

    mostrarAlerta = (icono, titulo, texto, timer = 3000) =>
        Swal.fire({ icon: icono, title: titulo, text: texto, timer, timerProgressBar: true, showConfirmButton: true, confirmButtonText: 'Entendido', zIndex: 2000 });

    mostrarConfirmacion = (titulo, texto, icono = 'warning') =>
        Swal.fire({ title: titulo, text: texto, icon: icono, showCancelButton: true, confirmButtonColor: '#d33', cancelButtonColor: '#3085d6', confirmButtonText: 'Sí, continuar', cancelButtonText: 'Cancelar', zIndex: 2000, reverseButtons: true });

    mostrarLoading = (titulo = 'Procesando...', texto = 'Por favor espere') =>
        Swal.fire({ title: titulo, text: texto, allowOutsideClick: false, didOpen: () => Swal.showLoading(), zIndex: 2000 });

    cerrarLoading = () => Swal.close();

    mostrarAdvertencia = (msg) => {
        this.setState({ warningMessage: msg });
        setTimeout(() => this.setState({ warningMessage: '' }), 5000);
    };

    // ── LocalStorage ──────────────────────────────────────────────────────────

    cargarSeleccionadasStorage = () => {
        try { const d = JSON.parse(localStorage.getItem(LS_KEY) || '{}'); return Array.isArray(d.ids) ? d.ids : []; }
        catch { return []; }
    };

    guardarSeleccionadasStorage = (ids, eps) => {
        try { localStorage.setItem(LS_KEY, JSON.stringify({ ids, eps, fecha: new Date().toISOString() })); } catch { }
        this.setState({ epsSeleccionada: eps });
    };

    limpiarStorage = () => localStorage.removeItem(LS_KEY);

    // ── Ciclo de vida ─────────────────────────────────────────────────────────

    componentDidMount() { this.cargarSelects(); }

    // ── Carga de catálogos desde mostrar_select ───────────────────────────────

    cargarSelects = async () => {
        try {
            const { data } = await authAxios.get('/ordenes/mostrar_select');
            const usuarios   = (data.usuarios   || []).map(u => ({ ...u, label: `${u.nombre} ${u.apellido}` }));
            const pacientes  = (data.pacientes  || []).map(p => ({ ...p, label: `${p.nombre} ${p.apellido}` }));
            const atenciones = (data.atenciones || []).map(a => ({ ...a, label: `${a.codigo} - ${a.nombre}`, value: a.id }));
            this.setState({ usuarios, pacientes, atenciones });
        } catch (err) {
            console.error('Error cargarSelects:', err);
            this.mostrarAlerta('error', 'Error', 'No se pudieron cargar los catálogos');
        }
    };

    // ── Carga de órdenes ──────────────────────────────────────────────────────

    cargarOrdenes = async (pagina = 1) => {
        if (!this.state.asignado) { this.mostrarAdvertencia('Seleccione un Asignado para buscar órdenes.'); return; }
        this.setState({ cargando: true, warningMessage: '' });
        try {
            const params = {};
            if (this.state.busqueda)    params.busqueda    = this.state.busqueda;
            if (this.state.paciente)    params.paciente    = this.state.paciente;
            if (this.state.atencion)    params.atencion    = this.state.atencion;
            if (this.state.fecha_desde) params.fecha_desde = this.state.fecha_desde;
            if (this.state.fecha_hasta) params.fecha_hasta = this.state.fecha_hasta;
            if (this.state.solo_revisados) params.revisado = 'Si';
            params.asignado   = this.state.asignado;
            params.pagina     = pagina;
            params.por_pagina = this.state.por_pagina;

            const { data } = await authAxios.post('/ordenes/mostrar_ordenes_liquidar', params);

            if (data.success) {
                const nuevasOrdenes = data.data;
                let selVal = [], epsVal = null;

                if (this.state.ordenesSeleccionadas.length > 0) {
                    const enc  = nuevasOrdenes.filter(o => this.state.ordenesSeleccionadas.includes(o.id) && o.factura === 0);
                    const epsU = [...new Set(enc.map(o => o.eps))];
                    if (enc.length > 0 && epsU.length === 1) { selVal = enc.map(o => o.id); epsVal = epsU[0]; }
                }

                this.setState({
                    ordenes: nuevasOrdenes,
                    total: data.total,
                    pagina_actual: data.pagina_actual,
                    ultima_pagina: data.ultima_pagina,
                    empresas:  data.empresas  || [],
                    regimenes: data.regimenes || [],
                    ordenesSeleccionadas: selVal,
                    epsSeleccionada: epsVal,
                    seleccionarTodos: selVal.length === nuevasOrdenes.length && nuevasOrdenes.length > 0
                });

                selVal.length > 0 ? this.guardarSeleccionadasStorage(selVal, epsVal) : this.limpiarStorage();
            }
        } catch (err) {
            console.error(err);
            this.mostrarAlerta('error', 'Error', 'No se pudieron cargar las órdenes');
        } finally {
            this.setState({ cargando: false });
        }
    };

    handleFilterChange = (e) => this.setState({ [e.target.name]: e.target.value });

    limpiarFiltros = () => this.setState({ busqueda: '', paciente: '', atencion: '', fecha_desde: '', fecha_hasta: '', solo_revisados: false, asignado: '' });

    buscar = () => {
        if (!this.state.asignado) { this.mostrarAdvertencia('Seleccione un Asignado antes de buscar.'); return; }
        this.cargarOrdenes(1);
    };

    cambiarPagina = (p) => { if (p >= 1 && p <= this.state.ultima_pagina) this.cargarOrdenes(p); };

    // ── Selección ─────────────────────────────────────────────────────────────

    puedeSeleccionarOrden = (orden) => {
        const { ordenesSeleccionadas, epsSeleccionada } = this.state;
        return ordenesSeleccionadas.length === 0 || orden.eps === epsSeleccionada;
    };

    toggleSeleccionOrden = (id) => {
        this.setState(prev => {
            const orden = prev.ordenes.find(o => o.id === id);
            if (!prev.ordenesSeleccionadas.includes(id) && !this.puedeSeleccionarOrden(orden)) {
                this.mostrarAdvertencia(`Solo órdenes de la misma EPS: ${this.getNombreEmpresa(prev.epsSeleccionada)}`);
                return prev;
            }
            let sel, eps = prev.epsSeleccionada;
            if (prev.ordenesSeleccionadas.includes(id)) {
                sel = prev.ordenesSeleccionadas.filter(oid => oid !== id);
                if (sel.length === 0) eps = null;
            } else {
                sel = [...prev.ordenesSeleccionadas, id];
                if (prev.ordenesSeleccionadas.length === 0) eps = orden.eps;
            }
            this.guardarSeleccionadasStorage(sel, eps);
            return { ordenesSeleccionadas: sel, epsSeleccionada: eps, seleccionarTodos: sel.length === prev.ordenes.length };
        });
    };

    toggleSeleccionarTodos = () => {
        this.setState(prev => {
            if (prev.seleccionarTodos) { this.guardarSeleccionadasStorage([], null); return { ordenesSeleccionadas: [], epsSeleccionada: null, seleccionarTodos: false }; }
            const epsU = [...new Set(prev.ordenes.map(o => o.eps))];
            if (epsU.length > 1) { this.mostrarAdvertencia('Múltiples EPS. Seleccione manualmente.'); return prev; }
            const sel = prev.ordenes.filter(o => o.revisado === 'Si' && o.factura === 0).map(o => o.id);
            const eps = sel.length > 0 ? prev.ordenes[0].eps : null;
            this.guardarSeleccionadasStorage(sel, eps);
            return { ordenesSeleccionadas: sel, epsSeleccionada: eps, seleccionarTodos: true };
        });
    };

    limpiarSeleccion = () => { this.setState({ ordenesSeleccionadas: [], epsSeleccionada: null, seleccionarTodos: false }); this.limpiarStorage(); };

    getNombreEmpresa = (id) => { const e = this.state.empresas.find(e => e.id == id); return e ? e.nombre : `EPS ${id}`; };
    getNombreUsuario = (id) => { const u = this.state.usuarios.find(u => u.id == id); return u ? u.label : `Usuario ${id}`; };

    // ── Modal ver orden ───────────────────────────────────────────────────────

    verOrdenModal = (orden) => {
        window.localStorage.setItem('Archivo', 200);
        window.localStorage.setItem('TablaId', orden.archivo);
        this.setState({ showModalOrden: true, ordenSeleccionada: orden });
    };

    cerrarModalOrden = () => { this.setState({ showModalOrden: false, ordenSeleccionada: null }); this.cargarOrdenes(this.state.pagina_actual); };

    // ── Modal liquidación ─────────────────────────────────────────────────────

    abrirModalLiquidacion = async (orden) => {
        this.setState({ cargandoCosto: true });
        try {
            let datos = {orden:orden.id}
            const { data } = await authAxios.post(`/ordenes/mostrar_costo`,datos);
            if (data.success) {
                const { costo, orden: o } = data;
                this.setState({
                    showModalLiquidacion: true, ordenLiquidar: o, costoLiquidar: costo,
                    liq_estado: 1,
                    liq_profesional: String(o.asignado    || ''),
                    liq_cantidad:    String(o.cantidad    || ''),
                    liq_valor_und:   String(costo         || ''),
                    liq_total:       String((costo * (o.cantidad || 1)) || ''),
                    liq_tipo:        String(o.tipo_orden  || ''),
                    liq_fecha_inicio: o.fecha_inicial     || '',
                    liq_fecha_final:  o.fecha_final       || '',
                    liq_atencion:    String(o.atencion_id || '')
                });
            } else {
                this.mostrarAlerta('error', 'Error', 'No se pudo obtener el costo de la orden');
            }
        } catch {
            this.mostrarAlerta('error', 'Error', 'No se pudo obtener la información de la orden');
        } finally {
            this.setState({ cargandoCosto: false });
        }
    };

    cerrarModalLiquidacion = () => this.setState({
        showModalLiquidacion: false, ordenLiquidar: null, costoLiquidar: 0,
        liq_estado: 1, liq_profesional: '', liq_cantidad: '', liq_valor_und: '',
        liq_total: '', liq_tipo: '', liq_fecha_inicio: '', liq_fecha_final: '', liq_atencion: '', guardandoLiq: false
    });

    handleLiquidacionChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value }, () => {
            if (name === 'liq_cantidad' || name === 'liq_valor_und') {
                const t = (parseFloat(this.state.liq_cantidad) || 0) * (parseFloat(this.state.liq_valor_und) || 0);
                this.setState({ liq_total: t.toFixed(2) });
            }
        });
    };

    guardarLiquidacion = async () => {
        const { ordenLiquidar, liq_estado, liq_profesional, liq_cantidad, liq_valor_und, liq_total, liq_tipo, liq_fecha_inicio, liq_fecha_final, liq_atencion } = this.state;
        if (!liq_cantidad || !liq_valor_und || !liq_total) { this.mostrarAlerta('warning', 'Campos requeridos', 'Complete cantidad, valor unitario y total.'); return; }
        this.setState({ guardandoLiq: true });
        this.mostrarLoading('Guardando liquidación...');
        try {
            const { data } = await authAxios.post('/ordenes/guardar_liquidacion', {
                estado: liq_estado, orden: ordenLiquidar.id, profesional: liq_profesional,
                cantidad: liq_cantidad, valor_und: liq_valor_und, total: liq_total,
                tipo: liq_tipo, fecha_inicio: liq_fecha_inicio, fecha_final: liq_fecha_final, atencion: liq_atencion
            });
            this.cerrarLoading();
            if (data.success) {
                await this.mostrarAlerta('success', '¡Liquidado!', 'Liquidación guardada correctamente', 2500);
                this.cerrarModalLiquidacion();
                this.cargarOrdenes(this.state.pagina_actual);
            } else {
                this.mostrarAlerta('error', 'Error', data.message || 'No se pudo guardar');
            }
        } catch (err) {
            this.cerrarLoading();
            this.mostrarAlerta('error', 'Error', err?.response?.data?.message || 'No se pudo guardar la liquidación');
        } finally {
            this.setState({ guardandoLiq: false });
        }
    };

    // ── Modal facturación ─────────────────────────────────────────────────────

    abrirModalFacturacion = () => {
        const { ordenesSeleccionadas, epsSeleccionada } = this.state;
        if (ordenesSeleccionadas.length === 0) { this.mostrarAlerta('warning', 'Atención', 'Seleccione al menos una orden'); return; }
        const noRev = this.state.ordenes.filter(o => ordenesSeleccionadas.includes(o.id) && o.revisado !== 'Si');
        if (noRev.length > 0) { this.mostrarAlerta('error', 'Error', 'Todas las órdenes deben estar revisadas'); return; }
        this.setState({ showModalFacturacion: true, epsFacturacion: epsSeleccionada || '', regimenFacturacion: '' });
    };

    cerrarModalFacturacion = () => this.setState({ showModalFacturacion: false, epsFacturacion: '', regimenFacturacion: '', facturando: false });

    facturarSeleccionadas = async () => {
        const { ordenesSeleccionadas, epsFacturacion, regimenFacturacion, ordenes } = this.state;
        if (!epsFacturacion)     { this.mostrarAlerta('error', 'Error', 'Seleccione la EPS'); return; }
        if (!regimenFacturacion) { this.mostrarAlerta('error', 'Error', 'Seleccione el régimen'); return; }
        this.cerrarModalFacturacion();
        const result = await this.mostrarConfirmacion('¿Confirmar facturación?', `Va a facturar ${ordenesSeleccionadas.length} orden(es)`);
        if (!result.isConfirmed) { this.setState({ showModalFacturacion: true }); return; }
        this.setState({ facturando: true });
        this.mostrarLoading('Facturando...');
        try {
            const { data } = await authAxios.post('/ordenes/facturar', {
                ids: ordenesSeleccionadas, eps: epsFacturacion, regimen: regimenFacturacion,
                ordenes: ordenes.filter(o => ordenesSeleccionadas.includes(o.id))
            });
            this.cerrarLoading();
            if (data.status) {
                await this.mostrarAlerta('success', '¡Factura Generada!', `Factura #${data.factura_id} generada`, 4000);
                this.limpiarSeleccion();
                await this.cargarOrdenes(this.state.pagina_actual);
            } else {
                this.mostrarAlerta('error', 'Error', data.message || 'Error al facturar');
            }
        } catch (err) {
            this.cerrarLoading();
            this.mostrarAlerta('error', 'Error', err?.response?.data?.message || 'Error al facturar');
            this.setState({ showModalFacturacion: true });
        } finally {
            this.setState({ facturando: false });
        }
    };

    // ── Render ────────────────────────────────────────────────────────────────

    render() {
        const {
            busqueda, paciente, atencion, asignado, fecha_desde, fecha_hasta, solo_revisados,
            ordenes, cargando, total, pagina_actual, ultima_pagina,
            ordenesSeleccionadas, seleccionarTodos, epsSeleccionada,
            showModalOrden, ordenSeleccionada,
            showModalLiquidacion, ordenLiquidar, costoLiquidar, cargandoCosto,
            liq_estado, liq_profesional, liq_cantidad, liq_valor_und, liq_total,
            liq_tipo, liq_fecha_inicio, liq_fecha_final, liq_atencion, guardandoLiq,
            showModalFacturacion, epsFacturacion, regimenFacturacion, facturando,
            usuarios, pacientes, atenciones, empresas, regimenes,
            warningMessage
        } = this.state;

        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">

                            {/* ENCABEZADO */}
                            <div className="card-header d-flex justify-content-between align-items-center">
                                <h5 className="mb-0"><b>LIQUIDAR ÓRDENES INTERNAS</b></h5>
                                <div>
                                    {epsSeleccionada && <span className="badge bg-info me-2">EPS: {this.getNombreEmpresa(epsSeleccionada)}</span>}
                                    {ordenesSeleccionadas.length > 0 && (
                                        <button className="btn btn-warning btn-sm me-2" onClick={this.limpiarSeleccion}>
                                            <FontAwesomeIcon icon={faTimes} /> Limpiar ({ordenesSeleccionadas.length})
                                        </button>
                                    )}
                                    <button className="btn btn-success btn-sm" onClick={this.abrirModalFacturacion} disabled={ordenesSeleccionadas.length === 0}>
                                        <FontAwesomeIcon icon={faFileInvoice} /> Facturar ({ordenesSeleccionadas.length})
                                    </button>
                                </div>
                            </div>

                            {/* ADVERTENCIA */}
                            {warningMessage && (
                                <div className="alert alert-warning alert-dismissible fade show m-3" role="alert">
                                    <FontAwesomeIcon icon={faExclamationTriangle} className="me-2" />
                                    {warningMessage}
                                    <button type="button" className="btn-close" onClick={() => this.setState({ warningMessage: '' })}></button>
                                </div>
                            )}

                            <div className="card-body">

                                {/* FILTROS */}
                                <div className="card bg-secondary mb-4">
                                    <div className="card-body">
                                        <h6 className="mb-3">Filtros de búsqueda</h6>
                                        <div className="row g-2">

                                            {/* Asignado — OBLIGATORIO */}
                                            <div className="col-md-3">
                                                <label className="form-label mb-1 fw-bold">
                                                    Asignado <span className="text-danger">*</span>
                                                </label>
                                                <SearchableSelect
                                                    opciones={usuarios}
                                                    value={asignado}
                                                    valueKey="id"
                                                    labelKey="label"
                                                    placeholder="-- Seleccione usuario --"
                                                    required={true}
                                                    onChange={val => this.setState({ asignado: val })}
                                                />
                                            </div>

                                            {/* Paciente */}
                                            <div className="col-md-3">
                                                <label className="form-label mb-1">Paciente</label>
                                                <SearchableSelect
                                                    opciones={pacientes}
                                                    value={paciente}
                                                    valueKey="id"
                                                    labelKey="label"
                                                    placeholder="-- Todos los pacientes --"
                                                    required={false}
                                                    onChange={val => this.setState({ paciente: val })}
                                                />
                                            </div>

                                            {/* Atención */}
                                            <div className="col-md-3">
                                                <label className="form-label mb-1">Atención</label>
                                                <SearchableSelect
                                                    opciones={atenciones}
                                                    value={atencion}
                                                    valueKey="value"
                                                    labelKey="label"
                                                    placeholder="-- Todas las atenciones --"
                                                    required={false}
                                                    onChange={val => this.setState({ atencion: val })}
                                                />
                                            </div>

                                            {/* Búsqueda general */}
                                            <div className="col-md-3">
                                                <label className="form-label mb-1">Búsqueda general</label>
                                                <input type="text" className="form-control form-control-sm"
                                                    name="busqueda" value={busqueda}
                                                    onChange={this.handleFilterChange}
                                                    placeholder="Orden externa..." />
                                            </div>

                                            {/* Fecha desde */}
                                            <div className="col-md-2">
                                                <label className="form-label mb-1">Fecha desde</label>
                                                <input type="date" className="form-control form-control-sm"
                                                    name="fecha_desde" value={fecha_desde} onChange={this.handleFilterChange} />
                                            </div>

                                            {/* Fecha hasta */}
                                            <div className="col-md-2">
                                                <label className="form-label mb-1">Fecha hasta</label>
                                                <input type="date" className="form-control form-control-sm"
                                                    name="fecha_hasta" value={fecha_hasta} onChange={this.handleFilterChange} />
                                            </div>

                                            {/* Solo revisados */}
                                            <div className="col-md-2 d-flex align-items-end pb-1">
                                                <div className="form-check">
                                                    <input type="checkbox" className="form-check-input" id="soloRevisados"
                                                        checked={solo_revisados}
                                                        onChange={e => this.setState({ solo_revisados: e.target.checked })} />
                                                    <label className="form-check-label" htmlFor="soloRevisados">Solo revisados</label>
                                                </div>
                                            </div>

                                            {/* Botones */}
                                            <div className="col-md-6 d-flex align-items-end gap-2">
                                                <button className="btn btn-primary btn-sm" onClick={this.buscar} disabled={!asignado}>
                                                    <FontAwesomeIcon icon={faSearch} /> Buscar
                                                </button>
                                                <button className="btn btn-secondary btn-sm" onClick={this.limpiarFiltros}>
                                                    <FontAwesomeIcon icon={faTimes} /> Limpiar
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* TABLA */}
                                <div className="table-responsive">
                                    <table className="table table-hover table-bordered table-sm">
                                        <thead className="table-primary">
                                            <tr>
                                                <th width="40">
                                                    Liquidar
                                                </th>
                                                <th>ID</th><th>Paciente</th><th>EPS</th><th>Orden Externa</th>
                                                <th>Atención</th><th>Diagnóstico</th><th>Fecha Inicial</th>
                                                <th>Fecha Final</th><th>Cantidad</th><th>%</th>
                                                <th>Revisado</th><th>Notas</th><th width="120">Acciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {cargando ? (
                                                <tr><td colSpan="14" className="text-center py-4">
                                                    <div className="spinner-border text-primary" role="status" />
                                                </td></tr>
                                            ) : ordenes.length === 0 ? (
                                                <tr><td colSpan="14" className="text-center text-muted py-3">
                                                    {asignado ? 'No hay órdenes para mostrar' : 'Seleccione un Asignado y haga clic en Buscar'}
                                                </td></tr>
                                            ) : ordenes.map(orden => {
                                                const pct = orden.porcentaje || 0;
                                                const revisado = orden.revisado === 'Si';
                                                const puedeFacturar = revisado && orden.factura === 0;
                                                const puedeSelec = this.puedeSeleccionarOrden(orden);
                                                const seleccionada = ordenesSeleccionadas.includes(orden.id);
                                                return (
                                                    <tr key={orden.id} className={`${revisado ? 'table-success' : ''} ${seleccionada ? 'table-primary' : ''}`}>
                                                        <td>
                                                            <button className="btn btn-warning btn-xs me-1"
                                                                onClick={() => this.abrirModalLiquidacion(orden)}
                                                                disabled={cargandoCosto} title="Liquidar">
                                                                <FontAwesomeIcon icon={faMoneyBillWave} /> Liquidar
                                                            </button>
                                                        </td>
                                                        <td>{orden.id}</td>
                                                        <td>{orden.nombre} {orden.apellido}<br /><small className="text-muted">CC: {orden.cedula}</small></td>
                                                        <td><span className="badge bg-secondary">{this.getNombreEmpresa(orden.eps)}</span></td>
                                                        <td>{orden.orden_externa}</td>
                                                        <td>{orden.atencion} {orden.nombre_atencion}</td>
                                                        <td>{orden.diagnostico}</td>
                                                        <td>{orden.fecha_inicial}</td>
                                                        <td>{orden.fecha_final}</td>
                                                        <td className="text-center">{orden.cantidad}</td>
                                                        <td>
                                                            <div className="progress" style={{ height: '20px' }}>
                                                                <div className={`progress-bar ${pct >= 100 ? 'bg-success' : pct >= 70 ? 'bg-info' : pct >= 40 ? 'bg-warning' : 'bg-danger'}`}
                                                                    role="progressbar" style={{ width: `${pct}%` }}>{pct}%</div>
                                                            </div>
                                                        </td>
                                                        <td className="text-center">
                                                            {revisado ? <FontAwesomeIcon icon={faCheckCircle} className="text-success" title="Revisado" /> : <span className="badge bg-secondary">Pendiente</span>}
                                                        </td>
                                                        <td>{orden.notas && <span title={orden.notas}><FontAwesomeIcon icon={faNotesMedical} className="text-info" /></span>}</td>
                                                        <td>
                                                            
                                                            <button className="btn btn-info btn-xs"
                                                                onClick={() => this.verOrdenModal(orden)} title="Ver">
                                                                <FontAwesomeIcon icon={faEye} />
                                                            </button>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>

                                {/* PAGINACIÓN */}
                                {!cargando && ordenes.length > 0 && (
                                    <div className="d-flex justify-content-between align-items-center mt-3">
                                        <div>Mostrando {ordenes.length} de {total} registros</div>
                                        <div>
                                            <button className="btn btn-sm btn-outline-primary me-2"
                                                onClick={() => this.cambiarPagina(pagina_actual - 1)} disabled={pagina_actual === 1}>
                                                <FontAwesomeIcon icon={faChevronLeft} /> Anterior
                                            </button>
                                            <span className="mx-2">Página {pagina_actual} de {ultima_pagina}</span>
                                            <button className="btn btn-sm btn-outline-primary ms-2"
                                                onClick={() => this.cambiarPagina(pagina_actual + 1)} disabled={pagina_actual === ultima_pagina}>
                                                Siguiente <FontAwesomeIcon icon={faChevronRight} />
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {/* MODAL VER ORDEN */}
                {showModalOrden && ordenSeleccionada && (
                    <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1060 }} tabIndex="-1">
                        <div className="modal-dialog modal-xl modal-dialog-scrollable">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Orden #{ordenSeleccionada.id} — {ordenSeleccionada.nombre} {ordenSeleccionada.apellido}</h5>
                                    <button type="button" className="btn-close" onClick={this.cerrarModalOrden}></button>
                                </div>
                                <div className="modal-body"><Ordenes /></div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={this.cerrarModalOrden}>
                                        <FontAwesomeIcon icon={faClose} /> Cerrar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* MODAL LIQUIDACIÓN */}
                {showModalLiquidacion && ordenLiquidar && (
                    <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1055 }} tabIndex="-1">
                        <div className="modal-dialog modal-lg">
                            <div className="modal-content">
                                <div className="modal-header bg-warning">
                                    <h5 className="modal-title"><FontAwesomeIcon icon={faMoneyBillWave} className="me-2" />Liquidar Orden #{ordenLiquidar.id}</h5>
                                    <button type="button" className="btn-close" onClick={this.cerrarModalLiquidacion} disabled={guardandoLiq}></button>
                                </div>
                                <div className="modal-body">

                                    {/* Resumen de la orden */}
                                    <div className="card mb-3 border-info">
                                        <div className="card-header bg-info text-white py-1"><strong>Información de la Orden</strong></div>
                                        <div className="card-body py-2">
                                            <div className="row g-2">
                                                <div className="col-md-4"><small className="text-muted d-block">Paciente</small><strong>{ordenLiquidar.paciente}</strong></div>
                                                <div className="col-md-4"><small className="text-muted d-block">Orden Externa</small>{ordenLiquidar.orden_externa}</div>
                                                <div className="col-md-4"><small className="text-muted d-block">Diagnóstico</small>{ordenLiquidar.diagnostico}</div>
                                                <div className="col-md-4"><small className="text-muted d-block">Atención</small>{ordenLiquidar.atencion}</div>
                                                <div className="col-md-2"><small className="text-muted d-block">Cantidad</small>{ordenLiquidar.cantidad}</div>
                                                <div className="col-md-3"><small className="text-muted d-block">Período</small>{ordenLiquidar.fecha_inicial} → {ordenLiquidar.fecha_final}</div>
                                                <div className="col-md-3"><small className="text-muted d-block">Valor Atención</small><span className="text-success fw-bold">${Number(ordenLiquidar.valor_atencion || 0).toLocaleString()}</span></div>
                                                <div className="col-md-3"><small className="text-muted d-block">Costo</small><span className="text-primary fw-bold">${Number(costoLiquidar).toLocaleString()}</span></div>
                                                <div className="col-md-3"><small className="text-muted d-block">Asignado</small>{this.getNombreUsuario(ordenLiquidar.asignado)}</div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Formulario */}
                                    <h6 className="text-muted mb-3">Datos de Liquidación</h6>
                                    <div className="row g-3">

                                        <div className="col-md-3">
                                            <label className="form-label">Estado</label>
                                            <select className="form-control form-control-sm" name="liq_estado" value={liq_estado} onChange={this.handleLiquidacionChange}>
                                                <option value={1}>Activo</option>
                                                <option value={0}>Inactivo</option>
                                            </select>
                                        </div>

                                        <div className="col-md-5">
                                            <label className="form-label">Profesional</label>
                                            <SearchableSelect
                                                opciones={usuarios} value={liq_profesional}
                                                valueKey="id" labelKey="label"
                                                placeholder="-- Seleccione profesional --"
                                                required={false}
                                                onChange={val => this.setState({ liq_profesional: val })}
                                            />
                                        </div>

                                        <div className="col-md-4">
                                            <label className="form-label">Tipo</label>
                                            <input type="number" className="form-control form-control-sm"
                                                name="liq_tipo" value={liq_tipo} onChange={this.handleLiquidacionChange} placeholder="Tipo" />
                                        </div>

                                        <div className="col-md-6">
                                            <label className="form-label">Atención</label>
                                            <SearchableSelect
                                                opciones={atenciones} value={liq_atencion}
                                                valueKey="value" labelKey="label"
                                                placeholder="-- Seleccione atención --"
                                                required={false}
                                                onChange={val => this.setState({ liq_atencion: val })}
                                            />
                                        </div>

                                        <div className="col-md-3">
                                            <label className="form-label">Fecha Inicio</label>
                                            <input type="date" className="form-control form-control-sm"
                                                name="liq_fecha_inicio" value={liq_fecha_inicio} onChange={this.handleLiquidacionChange} />
                                        </div>

                                        <div className="col-md-3">
                                            <label className="form-label">Fecha Final</label>
                                            <input type="date" className="form-control form-control-sm"
                                                name="liq_fecha_final" value={liq_fecha_final} onChange={this.handleLiquidacionChange} />
                                        </div>

                                        <div className="col-md-4">
                                            <label className="form-label">Cantidad <span className="text-danger">*</span></label>
                                            <input type="number" className="form-control form-control-sm"
                                                name="liq_cantidad" value={liq_cantidad} onChange={this.handleLiquidacionChange} min="1" />
                                        </div>

                                        <div className="col-md-4">
                                            <label className="form-label">Valor Unitario <span className="text-danger">*</span></label>
                                            <input type="number" className="form-control form-control-sm"
                                                name="liq_valor_und" value={liq_valor_und} onChange={this.handleLiquidacionChange} min="0" step="0.01" />
                                        </div>

                                        <div className="col-md-4">
                                            <label className="form-label">Total <span className="text-danger">*</span></label>
                                            <input type="number" className="form-control form-control-sm bg-light fw-bold"
                                                name="liq_total" value={liq_total} onChange={this.handleLiquidacionChange} min="0" step="0.01" />
                                            <small className="text-muted">Calculado: cantidad × valor</small>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-success" onClick={this.guardarLiquidacion} disabled={guardandoLiq}>
                                        {guardandoLiq ? <><span className="spinner-border spinner-border-sm me-1"></span>Guardando...</> : <><FontAwesomeIcon icon={faSave} /> Guardar Liquidación</>}
                                    </button>
                                    <button type="button" className="btn btn-secondary" onClick={this.cerrarModalLiquidacion} disabled={guardandoLiq}>Cancelar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* MODAL FACTURACIÓN */}
                {showModalFacturacion && (
                    <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1070 }} tabIndex="-1">
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Facturar {ordenesSeleccionadas.length} orden(es)</h5>
                                    <button type="button" className="btn-close" onClick={this.cerrarModalFacturacion} disabled={facturando}></button>
                                </div>
                                <div className="modal-body">
                                    <div className="alert alert-info">
                                        <strong>{ordenesSeleccionadas.length}</strong> órdenes seleccionadas
                                        {epsSeleccionada && <div><strong>EPS:</strong> {this.getNombreEmpresa(epsSeleccionada)}</div>}
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">EPS <span className="text-danger">*</span></label>
                                        <select className="form-control form-control-sm" value={epsFacturacion}
                                            onChange={e => this.setState({ epsFacturacion: e.target.value })} disabled={facturando}>
                                            <option value="">Seleccione EPS</option>
                                            {empresas.map(e => <option key={e.id} value={e.id}>{e.nombre} ({e.nit})</option>)}
                                        </select>
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Régimen <span className="text-danger">*</span></label>
                                        <select className="form-control form-control-sm" value={regimenFacturacion}
                                            onChange={e => this.setState({ regimenFacturacion: e.target.value })} disabled={facturando}>
                                            <option value="">Seleccione régimen</option>
                                            {regimenes.map(r => <option key={r.id} value={r.codigo}>{r.nombre}</option>)}
                                        </select>
                                    </div>
                                    <div style={{ maxHeight: '180px', overflowY: 'auto' }}>
                                        <table className="table table-sm table-bordered">
                                            <thead><tr><th>ID</th><th>Paciente</th><th>EPS</th><th>Orden</th></tr></thead>
                                            <tbody>
                                                {ordenes.filter(o => ordenesSeleccionadas.includes(o.id)).map(o => (
                                                    <tr key={o.id}><td>{o.id}</td><td>{o.nombre} {o.apellido}</td><td>{this.getNombreEmpresa(o.eps)}</td><td>{o.orden_externa}</td></tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-success" onClick={this.facturarSeleccionadas} disabled={facturando}>
                                        {facturando ? <><span className="spinner-border spinner-border-sm me-1"></span>Facturando...</> : <><FontAwesomeIcon icon={faFileInvoice} /> Confirmar</>}
                                    </button>
                                    <button type="button" className="btn btn-secondary" onClick={this.cerrarModalFacturacion} disabled={facturando}>Cancelar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default Liquidar;